/* ============================================================
   Sidebar — 사이드바 (카테고리·스키마 카탈로그)
   2026-05-13 App.tsx 분리
   ============================================================ */
import { CategoryDef } from '../../data'
import type { ViewState } from '../../types/board'

interface SidebarProps {
  filteredCategories: CategoryDef[]
  collapsed: Set<string>
  view: ViewState
  filter: string
  setFilter: (v: string) => void
  openHome: () => void
  openCategory: (name: string) => void
  openSchema: (catName: string, schemaName: string) => void
  toggleCollapse: (name: string) => void
}

export function Sidebar({
  filteredCategories, collapsed, view, filter, setFilter,
  openHome, openCategory, openSchema, toggleCollapse,
}: SidebarProps) {
  return (
    <aside className="sidebar">
      <div className="sidebar-header" onClick={openHome}>
        <h1>MG Board</h1>
        <div className="sub">v2 · MG-SYSTEM 메인 포털</div>
      </div>
      <div className="sb-filter">
        <input
          type="text"
          placeholder="schema filter..."
          autoComplete="off"
          value={filter}
          onChange={e => setFilter(e.target.value)}
        />
      </div>
      <div>
        {filteredCategories.map(cat => (
          <div
            key={cat.name}
            className={`cat-block ${collapsed.has(cat.name) ? 'cat-collapsed' : ''}`}
          >
            <div
              className={`cat-item ${view.categoryName === cat.name && view.mode === 'category' ? 'active' : ''}`}
              onClick={(e) => {
                if ((e.target as HTMLElement).closest('.twist')) {
                  toggleCollapse(cat.name)
                } else {
                  openCategory(cat.name)
                }
              }}
            >
              <span className="twist">▾</span>
              <span className="num">0{cat.order}</span>
              <span className="label">{cat.name}</span>
              <span className="count">{cat.schemas.length}</span>
            </div>
            <div className="schema-list">
              {cat.schemas.map(s => (
                <div
                  key={s}
                  className={`schema-item ${view.schemaName === s ? 'active' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation()
                    openSchema(cat.name, s)
                  }}
                >
                  <span>{s}</span>
                  <span className="schema-count">—</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </aside>
  )
}
